import React from 'react';

import Banner, { BannerVariant } from 'components/Banner/Banner';
import Panel from 'components/Panel/Panel';
import { PaymentDetails } from 'hooks/useGetPaymentDetails';
import { t } from 'locales/i18n';

interface PaymentDetailsProps {
  details: PaymentDetails;
}

const PaymentInfo = ({ details }: PaymentDetailsProps) => (
  <Panel panelClassName="mt-6">
    <Banner
      message={t('Payment details are read-only.')}
      contactLink
      requestChangesTo="payment"
      variant={BannerVariant.INFO}
    />

    <div className="flex">
      <p className="prose-body-md-med w-[50%]">{t('Amount')}</p>
      <p className="prose-body-md-reg w-60 border-b text-kira-slate-700">
        ${details.amount}
      </p>
    </div>
    <div className="flex">
      <p className="prose-body-md-med w-[50%]">{t('Currency')}</p>
      <p className="prose-body-md-reg w-60 border-b text-kira-slate-700">
        {details.currency}
      </p>
    </div>
  </Panel>
);

export default PaymentInfo;
